<script>
import { mapState } from 'vuex';
import ContactForm from '../../components/contactForm.vue';
import IpImagesSwiper from '../../components/ipImagesSwiper.vue';
import ipSwiperList from '../../components/ipSwiperList.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "ipDetail",
    data() {
        return {
            detail: {
                banner: [],
                case_list: [],
                goods: [],
            },
            isLoading: true,
        };
    },
    computed: {
        ...mapState(['talentMenu']),
    },
    components: {
        ContactForm,
        IpImagesSwiper,
        ipSwiperList,
        Loading
    },
    mounted() {
        this.$store.dispatch('getTalentIp', {
            id: this.$route.query.id
        }).then((result) => {
            this.isLoading = false;
            if (result.code == 100) { 
                this.detail = result.data;
                // 更新菜单索引
                if (this.talentMenu.length > 0) { 
                    this.getActiveIndex();
                }
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {
        talentMenu: {
            handler: function (value) { 
                if (value.length > 0 && this.detail.category_id) { 
                    this.getActiveIndex();
                }
            },
            // immediate: true
        }
    },
    methods: {
        // 获取对应路由的索引值
        getActiveIndex() { 
            // 父级路由
            let path = `/talents/ip?id=${this.detail.category_id}`;
            // 循环菜单找到对应的索引值
            for (let i = 0; i < this.talentMenu.length; i++) {
                const item = this.talentMenu[i];
                for (let j = 0; j < item.children.length; j++) {
                    const _item = item.children[j];
                    if (_item.link == path) { 
                        // 匹配到二级
                        this.$store.state.TMActiveIndex = [i, j, 0];
                        break;
                    }else if (_item.children.length > 0) {
                        // 二级没有，检查三级
                        const index = _item.children.findIndex(v => v.link == path);
                        if (index != -1) { 
                            this.$store.state.TMActiveIndex = [i, j, index];
                            break;
                        }
                    }
                }
            }
        },
    },
};
</script>

<template>
    <div class="ip_detail">
        <Loading v-if="isLoading"/>
        <div class="wrapper layout_main" v-else>
            <div class="flex top">
                <IpImagesSwiper :data="detail.banner"/>
                <div class="info flex flex_column justify_between">
                    <div>
                        <div class="name">{{ detail.name }}形象介绍</div>
                        <div class="desc">{{ detail.desc }}</div>
                    </div>
                    <div class="btn_group flex">
                        <p class="btn layout_flex_center" href="">免费桌面和表情</p>
                        <p class="btn layout_flex_center" href="">动漫连载</p>
                        <a class="btn layout_flex_center" v-if="detail.works_link" :href="detail.works_link" target="_blank">可授权作品库</a>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="content" v-if="detail.case_list.length > 0">
                <div class="title">授权案例</div>
                <div class="list case flex flex_wrap">
                    <a class="item" v-for="(item, index) in detail.case_list" :key="index" :href="item.link" target="_blank">
                        <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                        <div class="name">{{ item.name }}</div>
                    </a>
                </div>
                <div class="flex justify_end" v-if="detail.case_more">
                    <a class="layout_btn_more" :href="detail.case_more" target="_blank">了解更多</a>
                </div>
            </div>
            <!--  -->
            <div class="content" v-if="detail.goods.length > 0">
                <div class="title">商品</div>
                <div class="only_pc">
                    <ipSwiperList :data="detail.goods" path="/shop/detail"/>
                </div>
                <div class="only_mobile">
                    <div class="list goods flex flex_wrap">
                        <router-link class="item" v-for="(item, index) in detail.goods" :key="index" :to="`/shop/detail?id=${item.id}`">
                            <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                            <div class="name">{{ item.name }}</div>
                            <!-- <div class="price" v-if="item.price">RMB {{ item.price }}</div> -->
                        </router-link>
                    </div>
                </div>
                <!-- <div class="flex justify_end">
                    <div class="layout_btn_more">了解更多</div>
                </div> -->
            </div>
            <!--  -->
            <div class="content" v-if="detail.news.length > 0">
                <div class="title">活动和新闻</div>
                <ipSwiperList :data="detail.news" path="/news/detail"/>
                <!-- <div class="flex justify_end">
                    <div class="layout_btn_more">了解更多</div>
                </div> -->
            </div>
        </div>
        <ContactForm from="人才"/>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding-bottom: .7rem;
}
.top{
    @media only screen and (max-width: 750px) {
        display: block;
    }
}
.info{
    flex: 1;
    padding: 0 .4rem;
    @media only screen and (max-width: 750px) {
        padding: .4rem 0;
    }
    .name{
        text-align: center;
        font-size: .25rem;
        margin-bottom: .4rem;
        padding-top: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            margin-bottom: .3rem;
        }
    }
    .desc{
        font-size: .18rem;
        text-align: justify;
        line-height: 2;
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            line-height: 1.8;
            margin-bottom: .5rem;
        }
    }
    .btn_group{
        gap: .2rem;
        margin-top: .3rem;
        .btn{
            flex: auto;
            border: 1px solid #000;
            border-radius: .1rem;
            // width: 1.74rem;
            height: .5rem;
            font-size: .2rem;
        }
        @media only screen and (max-width: 750px) {
            gap: .3rem;
            .btn{
                height: .6rem;
                font-size: .28rem;
                // padding: 0 .2rem;
                white-space: nowrap;
            }
        }
    }
}
.content{
    padding-top: .4rem;
    .title{
        font-size: .25rem;
        text-align: center;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .28rem;
            margin-bottom: .3rem;
            font-weight: bold;
        }
    }
    @media only screen and (max-width: 750px) {
        .layout_btn_more{
            margin: .4rem auto 0;
        }
    }
}
.list{
    gap: .3rem;
    .item{
        width: 3.8rem;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: .2rem;
        .bg{
            height: 0;
            padding-bottom: 100%;
            margin-bottom: .1rem;
        }
        .name{
            font-size: .18rem;
            text-align: center;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        &.case{
            gap: .2rem;
            .item{
                width: 100%;
                margin-bottom: 0;
                .name{
                    font-size: .26rem;
                }
                .bg{
                    height: 3.36rem;
                    padding-bottom: 0;
                    margin-bottom: .2rem;
                }
            }
        }
        &.goods{
            gap: 0 .3rem;
            .item{
                width: 3.3rem;
            }
        }
    }
}
</style>